/* pt-article (the page types run, 2026-09-30): the sizer on ring-size-chart and the taps of the article block. Loaded (defer) only by
   snippets/pt-article.liquid. Nothing moves on load: the chips strip scrolls to the picked size inside itself, and every other change
   follows a tap or a drag (0 layout shift from pt- elements). sms:, tel: and the chat link are counted by hb-script, never here. */
(function () {
  if (window.__ptArticle) return; window.__ptArticle = 1;
  var B = document.getElementById('pt-article'); if (!B) return;
  var H = B.getAttribute('data-ph') || '';
  function emit(kind, part, url, ev) {
    try { if (window.traxEmit) window.traxEmit(ev || 'select_promotion', { promotion_id: 'article-' + kind, promotion_name: H + '|' + part, creative_slot: H, link_url: url || location.pathname }); } catch (e) {}
  }
  var S = document.getElementById('pt-sizer');
  if (S) {
    var R = S.querySelector('.pt-range'), C = S.querySelector('.pt-circle circle'), T = S.querySelector('.pt-circle text'),
      O = document.getElementById('pt-result'), X = S.querySelector('.pt-chips'), sms = S.querySelector('.pt-ph'),
      chat = S.querySelector('.pt-chat'), rs = S.getAttribute('data-sms') || '', rc = S.getAttribute('data-chat') || '', moved = 0;
    var k = parseFloat(getComputedStyle(S).getPropertyValue('--k')) || 5.5;
    if (R) {
      R.value = k;
      R.addEventListener('input', function () { S.style.setProperty('--k', R.value + 'px'); });
      R.addEventListener('change', function () { if (!moved) { moved = 1; emit('sizer-card', 'sizer-card'); } });
    }
    var put = function (sel, v) { var e = O && O.querySelector('[data-o="' + sel + '"]'); if (e) e.textContent = v; };
    var pick = function (b) {
      var s = b.getAttribute('data-s'), a = b.getAttribute('data-a'), r = b.getAttribute('data-r'), u = b.getAttribute('data-u') || '';
      X.querySelectorAll('.pt-chip').forEach(function (c) { c.setAttribute('aria-pressed', c === b ? 'true' : 'false'); });
      var bx = parseFloat(a) + 2, h = (bx / 2).toFixed(2), svg = S.querySelector('.pt-circle');
      if (svg) { svg.setAttribute('viewBox', '0 0 ' + bx.toFixed(1) + ' ' + bx.toFixed(1)); svg.style.setProperty('--d', bx.toFixed(1)); }
      if (C) { C.setAttribute('cx', h); C.setAttribute('cy', h); C.setAttribute('r', (parseFloat(a) / 2).toFixed(3)); }
      if (T) { T.textContent = s; T.setAttribute('x', h); T.setAttribute('y', (bx / 2 + 2.5).toFixed(2)); }
      put('a', a + ' mm'); put('r', r + ' mm'); put('e', 'about ' + b.getAttribute('data-e')); put('u', /^past/.test(u) ? u : (u ? 'about ' + u : ''));
      if (O) O.setAttribute('aria-label', 'Size ' + s + ': ' + a + ' mm across, ' + r + ' mm around.');
      if (svg) svg.setAttribute('aria-label', 'A circle ' + a + ' mm across, the inside of a size ' + s + ' ring');
      if (sms && rs) sms.setAttribute('href', 'sms:+12128729692?&body=' + encodeURIComponent(rs.replace('{s}', s)));
      if (chat && rc) chat.setAttribute('data-chat-draft', rc.replace('{s}', s));
      emit('size', 'size-' + s);
    };
    if (X) {
      X.addEventListener('click', function (e) { var b = e.target.closest('.pt-chip'); if (b) pick(b); });
      var on = X.querySelector('[aria-pressed="true"]');
      if (on) X.scrollLeft = Math.max(0, on.getBoundingClientRect().left - X.getBoundingClientRect().left + X.scrollLeft - (X.clientWidth - on.offsetWidth) / 2);
    }
  }
  B.addEventListener('click', function (e) {
    var a = e.target.closest('[data-pt]'); if (!a || !B.contains(a)) return;
    var pt = a.getAttribute('data-pt');
    if (pt === 'all') emit('all', 'all', a.getAttribute('href'));
    else if (pt === 'tile' && !e.target.closest('button')) emit('tile', 'tile' + a.getAttribute('data-n'), a.getAttribute('data-u'));
  }, true);     // capture: the card's own onclick navigates, so the tap is sent first
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) { emit('view', 'view', 0, 'view_promotion'); io.disconnect(); break; }
    }, { threshold: 0.25 });
    io.observe(B);
  }
})();
